// extracted by mini-css-extract-plugin
export default {"content":"style_content__nkFua","divider":"style_divider__Hx1vj","dividerText":"style_dividerText__BUEzn"};